import { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface AltFeatureProps {
  id?: string
  eyebrow?: string
  title: string
  description: string | ReactNode
  media: ReactNode
  reverse?: boolean
  primaryCta?: ReactNode
  secondaryCta?: ReactNode
  className?: string
}

export function AlternatingFeatureSection({ id, eyebrow, title, description, media, reverse, primaryCta, secondaryCta, className }: AltFeatureProps) {
  return (
    <section id={id} className={cn("py-20 md:py-28", className)}>
      <div className="mx-auto w-full max-w-screen-2xl px-6 md:px-12 grid md:grid-cols-12 gap-12 items-center">
        <div className={cn("md:col-span-6 flex flex-col", reverse && "md:order-2")}>          
          {eyebrow && <div className="mb-4 inline-flex items-center text-xs font-semibold tracking-wide uppercase text-blue-600 dark:text-indigo-300">{eyebrow}</div>}
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white leading-tight mb-6">{title}</h3>
          <div className="prose prose-blue dark:prose-invert max-w-none text-gray-600 dark:text-gray-300 text-base leading-relaxed mb-8">
            {description}
          </div>
          <div className="flex flex-wrap gap-4">
            {primaryCta}
            {secondaryCta}
          </div>
        </div>
        <div className={cn("md:col-span-6 relative", reverse && "md:order-1")}>          
          <div className="hover-glow-card relative rounded-2xl bg-white/60 dark:bg-zinc-800/50 backdrop-blur-sm shadow-lg p-4 min-h-[260px] flex items-center justify-center">
            {media}
          </div>
        </div>
      </div>
    </section>
  )
}
